import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import DeviceRepository from '@/services/repository/DeviceRepository';
import SortDirections from '@/entities/enums/SortDirections';
import VueUtilities from '@/services/VueUtilities';
var deviceRepository;
let ReadDataFromLoggerModal = class ReadDataFromLoggerModal extends Vue {
    constructor() {
        super(...arguments);
        this.devices = [];
        this.selectedDevice = null;
        this.isLoading = true;
        this.selectedEventTypes = ['temperature'];
        this.dateTimeFrom = new Date();
        this.dateTimeTo = new Date();
        this.hourFormat = '24';
        this.today = new Date();
    }
    async created() {
        deviceRepository = new DeviceRepository(this);
        //set default date range to 3 hours
        this.dateTimeFrom.setHours(this.dateTimeFrom.getHours() - 3);
        this.loadData();
    }
    read() {
        this.$validator.validateAll().then(async (result) => {
            if (result) {
                if (this.dateTimeTo.getTime() <= this.dateTimeFrom.getTime()) {
                    VueUtilities.openErrorToast(this, this.$t('admin.component.loggers.detail.info.readData.range_error'));
                    return;
                }
                let dto = {
                    DeviceInstanceId: this.selectedDevice.deviceId,
                    EventTypes: this.selectedEventTypes,
                    From: this.dateTimeFrom.toISOString(),
                    To: this.dateTimeTo.toISOString()
                };
                this.$emit('readData', dto);
            }
        });
    }
    async loadData() {
        let allPromises = [];
        const filters = ['InstanceState==Active'];
        const sort = { field: 'SerialName', direction: SortDirections.DESCENDING };
        allPromises.push(deviceRepository.getDevices(null, sort, filters));
        Promise.all(allPromises).then((response) => {
            this.processLoadedData(response[0]);
        });
    }
    processLoadedData(devices) {
        this.devices = devices.getData();
        this.selectedDevice = this.devices[0];
        this.isLoading = false;
    }
    resultRetrieved(event) {
        this.$emit('modalClosed', event);
    }
    clearDateTimeFrom() {
        this.dateTimeFrom = null;
    }
    clearDateTimeTo() {
        this.dateTimeTo = null;
    }
};
__decorate([
    Prop({ type: Object })
], ReadDataFromLoggerModal.prototype, "logger", void 0);
__decorate([
    Prop({ type: Object })
], ReadDataFromLoggerModal.prototype, "dateTimeManager", void 0);
ReadDataFromLoggerModal = __decorate([
    Component({})
], ReadDataFromLoggerModal);
export default ReadDataFromLoggerModal;
